import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment'
import { MediaInfo } from '../shared/models/general/media-info';
import { Media } from '../shared/models/general/media';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/media/';

  constructor(private http: HttpClient, public router: Router) { }

  public DownloadMedia(id: number): Observable<any> {
    return this.http.get<any>(this.apiUrl + 'download/' + id, { observe: 'response' })
      .pipe(
        map(res => {
          if (res) {
            if (res.status == 200) {
              return new MediaInfo().deserialize(res.body);
            }
          }
        })
      );
  }

  public GetMediaByEntityType(entityType: string, id: number): Observable<any> {
    return this.http.get<any>(this.apiUrl + 'entity-type/' + entityType + "/" + id, { observe: 'response' })
      .pipe(
        map(res => {
          if (res) {
            if (res.status == 200) {
              return res.body.map((data: any) => new Media().deserialize(data));
            }
          }
        })
      );
  }

  public GetFiaSupportingDocuments(userid: number, fiaSupportingMediaType: number): Observable<any> {
    return this.http.get<any>(this.apiUrl + 'fia-supporting-media/' + userid + '/' + fiaSupportingMediaType, { observe: 'response' })
      .pipe(
        map(res => {
          if (res) {
            if (res.status == 200) {
              return res.body.map((data: any) => new MediaInfo().deserialize(data));
            }
          }
        })
      );
  }

  public UploadMedia(media: MediaInfo): Observable<any> {
    return this.http.post<any>(this.apiUrl + 'upload', media, { observe: 'response' })
      .pipe(
        map(res => {
          if (res) {
            if (res.status == 200) {
              return;
            }
          }
        })
      );
  }

  public UploadMediaAsync(media: MediaInfo){
    return new Promise(resolve => {
      this.UploadMedia(media).subscribe(()=>{
        resolve(true);
      },((error) =>{
        resolve(error);
      }));
    });
  }

  public UploadFiaSupportingMedia(userId: number, fiaApplicationId:number,media: MediaInfo): Observable<any> {
    return this.http.post<any>(this.apiUrl + 'fiasupportingmedia/' + userId + '/' + fiaApplicationId, media, { observe: 'response' })
      .pipe(
        map(res => {
          if (res) {
            if (res.status == 200) {
              return;
            }
          }
        })
      );
  }

  public UploadFiaSupportingMediaAsync(userId: number, fiaApplicationId:number,media: MediaInfo){
    return new Promise((resolve, reject) => {
      this.UploadFiaSupportingMedia(userId, fiaApplicationId, media).subscribe(
        () => {
          resolve(true);
        },
        (error) => {
          console.log("Error" + error);
          reject(error);
        }
      )
    });
  }

  public DeleteMedia(id: number): Observable<any> {
    return this.http.delete<any>(this.apiUrl + 'delete/' + id, { observe: 'response' })
      .pipe(
        map(res => {
          if (res) {
            if (res.status == 204) {
              return;
            }
          }
        })
      );
  }

  public DeleteMediaAsync(id: number){
    return new Promise(resolve => {
      this.DeleteMedia(id).subscribe(()=>{
        resolve(true);
      },((error) =>{
        resolve(error);
      }));
    });
  }

  public Download(media: MediaInfo) {
    var Data = media.data;
    var file = this.B64toBlob(atob(Data), media.mimeType);
    var a = document.createElement("a"), url = URL.createObjectURL(file);
    a.href = url;
    a.download = media.fileName;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }

  private B64toBlob(byteCharacters: string, MimeType: string) {
    const sliceSize = 512;
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: MimeType });
    return blob;
  }
}
